const truncateName = (name: string): string => {
  const [firstName, ...restOfName] = name.split(' ');
  const [firstLetter] = firstName;
  return `${firstLetter}. ${restOfName.join(' ')}`;
};
export default truncateName;
